import React, { useState, useEffect } from "react";
import prodVuoto from "../prodottoVuoto";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";
import { useAuth0 } from '@auth0/auth0-react';

function InputCodice(props) {

  const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [input, setInput] = useState("");
  const utente = props.utente;
  const setProductFunction = props.setProductFunction;
  const onSearchResults = props.onSearchResults;
  const showLabels = props.showLabels;
  const showDescs = props.showDescs;
  const showTasto = props.showTasto;
  const orientamento = props.orientamento;
  let inputStyle;

  const {
    buttonClassesWhite  
} = stilePulsanti

  if (orientamento === "verticale") {
    inputStyle = "measure"
  } else if (orientamento === "orizzontale") {
    inputStyle = "pr4 pl4 black-80 flex measure"
  } else if (orientamento === "tasto") {
    inputStyle = "black-80 flex measure"
  }


  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    const codVS = input;
    console.log(codVS);


    if (!utente.permessiAPI["post:database"] && utente.permessiAPI["update:dbrevisioni"]) {
      //riciclo l'altra funzione per non aggiornare anche quella semplice
      fetch(apiUrl + "/prodotti/prodotto/showorcreateIDPSREV/"+codVS+"/NULL/NULL/NULL", { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => {
        if (typeof onSearchResults === "function") {
          onSearchResults(data, {
            tipoRicerca: "codice VS",
            valoreRicerca: codVS,
          });
          return;
        }
        setProductFunction(data[0] || prodVuoto);
      })
    } else if (utente.permessiAPI["post:database"]) {
      fetch(apiUrl + "/prodotti/prodotto/showorcreate/" + codVS, { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => {
        if (typeof onSearchResults === "function") {
          onSearchResults(data, {
            tipoRicerca: "codice VS",
            valoreRicerca: codVS,
          });
          return;
        }
        setProductFunction(data[0] || prodVuoto);
      })
    }


    
  }

  return (
    <div className="h-100 mb2">
      <form onSubmit={handleSubmit} class={inputStyle}>
        {/* <div class="measure"> */}
        {showLabels && <label for="name" class="b db mr2">Codice VS</label>}
        <input value={input} onChange={e => setInput(e.target.value)} id="name" className="input-reset ba bordoColScrittaDef-20 pa2 db w-100" type="text" aria-describedby="name-desc" autoComplete="off" />
        {/* <input type="submit" value="Submit" /> */}
        {showDescs && <small id="name-desc" class="f6 scrittaDef db mb2">Crea nuovo codice. Se già presente in database verrà aperto il documento esistente</small>}
        {orientamento === "tasto" && <button className={stilePulsanti.classiTastoSblocco} onClick={handleSubmit}><span class="material-icons md-13 gray ma1">search</span></button>}
        {/* </div> */}
        {showTasto && <br />}
        {showTasto && <button className={buttonClassesWhite} onClick={handleSubmit}>Crea/apri</button>}

      </form>
    </div>
  );

}

export default InputCodice;



